import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, Loading } from 'ionic-angular';
import { AwsProvider } from '../../providers/aws/aws';
import { UsersProvider } from '../../providers/users/users';

@IonicPage()
@Component({
  selector: 'page-file-upload',
  templateUrl: 'file-upload.html',
})
export class FileUploadPage {

  // variables for table sorting
  fileSym: string;
  fileField: string;

  // variables for upload popup
  showPopup: boolean;
  user: object;
  s3Files: Array<object>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public aws: AwsProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public usersPro: UsersProvider) {
  }

  ionViewDidEnter() {
    this.usersPro.populateUsers(true,false);
  }

  /**
   * Sort table depending on which column was clicked on
   * @param key object key to sort on
   */
  sortFileTable(key) {
    // return if not enough entries
    if (!this.s3Files || this.s3Files.length < 2) {
      return
    }

    // set current sort field to key
    this.fileField = key;

    // get current order of column as a string
    let order: String = JSON.stringify(this.s3Files.map(item => item[key]));

    // sort ascendingly
    this.s3Files.sort((a, b) => {
      if (typeof a[key] == 'number') {
        if (a[key] < b[key]) return -1;
        else if (a[key] > b[key]) return 1;
        else return 0;
      } else {
        if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
        else if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
        else return 0;
      }
    });

    // check to see if order changed at all
    // if order did not change, it's already sorted. Do descending instead
    let newOrder: String = JSON.stringify(this.s3Files.map(item => item[key]));
    if (order == newOrder) {
      this.fileSym = '▼';
      this.s3Files.sort((a, b) => {
        if (typeof a[key] == 'number') {
          if (a[key] < b[key]) return 1;
          else if (a[key] > b[key]) return -1;
          else return 0;
        } else {
          if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
          else if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
          else return 0;
        }
      });
    } else {
      this.fileSym = '▲'
    }
  }

  bringUpFileUpload(user: object) {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    this.user = user;
    this.showPopup = true;
    return this.aws.invokeLambda('LambdaGetUserFiles:ACTIVE', { cognitoId: user['cognitoId'] })
      .then((result) => {
        console.log("result of LambdaGetUserFiles");
        console.log(result);
        if (result['success']) {
          console.log("lambda get-user-files worked")
          this.s3Files = result['response']['files'];
        } else {
          console.log("lambda get-user-files failed");
          let msg = result['message'] || 'Error getting files. Please try again.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
        loading.dismiss();
      });
  }

  deleteFile(name: string, noConfirm?: boolean) {
    if (!noConfirm) {
      let msg = 'Are you sure you want to delete ' + name + '?';
      let alert = this.alertCtrl.create({
        message: msg,
        buttons: [
          'No',
          {
            text: 'Yes',
            handler: () => {
              this.deleteFile(name, true);
            }
          }
        ],
        enableBackdropDismiss: false
      });
      alert.present();
    } else {
      let loading: Loading = this.loadingCtrl.create({});
      loading.present();
      const params: object = { cognitoId: this.user['cognitoId'], name: name };
      this.aws.invokeLambda('LambdaDeleteUserFile:ACTIVE', params)
        .then((result) => {
          console.log("result of LambdaDeleteUserFile");
          console.log(result);
          if (result['success']) {
            let msg = result['message'] || 'File successfully deleted.';
            let alert = this.alertCtrl.create({
              message: msg,
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                    this.bringUpFileUpload(this.user);
                  }
                }
              ],
              enableBackdropDismiss: false
            });
            alert.present();
          } else {
            let msg = result['message'] || 'Error deleting file. Please try again.';
            let alert = this.alertCtrl.create({
              message: msg,
              buttons: ['Ok'],
              enableBackdropDismiss: false
            });
            alert.present();
          }
          loading.dismiss();
        });
    }
  }

  bringUpFileChooser() {
    let input: any = document.querySelector('input#upload-selection');
    input.click();
  }

  onFileSubmit() {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    let input: any = document.getElementById("upload-selection");
    let file = input.files[0];
    if (file) {
      if (file.size > 10000000) { // 10 mb
        let alert = this.alertCtrl.create({
          message: 'File must be 10mb or smaller.',
          buttons: ['Ok'],
          enableBackdropDismiss: false
        });
        alert.present();
        loading.dismiss();
      } else {
        let params: object = { cognitoId: this.user['cognitoId'], name: file.name, type: file.type };
        this.aws.invokeLambda('LambdaGetUserFileUploadUrl:ACTIVE', params)
          .then((result) => {
            console.log("result of LambdaGetUserFileUploadUrl");
            console.log(result);
            if (result['success']) {
              let url: string = result['response']['url'];
              this.uploadFile(url, file)
                .then((result) => {
                  console.log(JSON.stringify(result));
                  let alert = this.alertCtrl.create({
                    message: 'File successfully uploaded.',
                    buttons: [
                      {
                        text: 'Ok',
                        handler: () => {
                          this.bringUpFileUpload(this.user);
                        }
                      }
                    ],
                    enableBackdropDismiss: false
                  });
                  alert.present();
                  loading.dismiss();
                })
                .catch((error) => {
                  console.log(JSON.stringify(error));
                  let alert = this.alertCtrl.create({
                    message: 'Error uploading file. Please try again.',
                    buttons: ['Ok'],
                    enableBackdropDismiss: false
                  });
                  alert.present();
                  loading.dismiss();
                })
            } else {
              let alert = this.alertCtrl.create({
                message: 'Error getting file upload url. Please try again.',
                buttons: ['Ok'],
                enableBackdropDismiss: false
              });
              alert.present();
              loading.dismiss();
            }
          });
      }
    }
  }

  uploadFile(url, file) {
    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve();
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);
    });
  }

  downloadFile(name) {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    let params: object = { cognitoId: this.user['cognitoId'], name: name };
    this.aws.invokeLambda('LambdaGetUserFileDownloadUrl:ACTIVE', params)
      .then((result) => {
        if (result['success']) {
          try {
            let url: string = result['response']['url'];
            window.open(url);
            loading.dismiss();
          } catch (error) {
            console.log(JSON.stringify(error));
            let alert = this.alertCtrl.create({
              message: 'Error downloading file. Please try again.',
              buttons: ['Ok'],
              enableBackdropDismiss: false
            });
            alert.present();
            loading.dismiss();
          }
        } else {
          let alert = this.alertCtrl.create({
            message: 'Error downloading file. Please try again.',
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
          loading.dismiss();
        }
      })
  }

  /**
   * Given a number of bytes and a specified amount of
   * decimals, format into the proper denomination
   * @param bytes number of bytes
   * @param decimals number of decimals required
   */
  formatBytes(bytes, decimals) {
    if (bytes == 0) return '0 Bytes';
    var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  closePopup() {
    this.showPopup = false;
    setTimeout(() => {
      this.user = null;
      this.s3Files = null;
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/pages/file-upload/file-upload.ts